<template>
  <div :class="width" class="p-1">
    <div class="h-64 shadow bg-secondary">
      <router-link
        :to="{
          path: '/movies/',
          name: 'MovieDetails',
          params: {
            id: data.id
          }
        }"
      >
        <img
          :src="imageUrl(data['poster_path'])"
          :alt="data['title']"
          class="w-full h-full"
        />
      </router-link>
    </div>
    <div class="bg-secondary p-2 flex flex-col" style="min-height: 150px;">
      <span class="text-yellow-500 block mb-2"
        ><i class="fas fa-star mr-2"></i> {{ data["vote_average"] }}</span
      >
      <span class="text-sm">
        <router-link
          :to="{
            path: '/movies/',
            name: 'MovieDetails',
            params: {
              id: data.id
            }
          }"
        >
          {{ data["title"] }}
          ({{ getYear(data["release_date"] || data["first_air_date"]) }})
        </router-link>
      </span>
      <div class="flex-1" />
      <div class="mt-2 pb-2">
        <ul class="flex justify-between">
          <li class="xs:mr-2 mr-0">
            <button-icon
              :style="'bg-gray-700'"
              :color="'text-white'"
              :tippy_content="'Add to favourite'"
              ><i class="fas fa-heart"></i
            ></button-icon>
          </li>
          <li>
            <button-icon
              :style="'bg-gray-700'"
              :color="'text-white'"
              :tippy_content="'Add to watchlist'"
              ><i class="fas fa-plus"></i
            ></button-icon>
          </li>
          <li class="hidden xs:block flex-1" />
          <li>
            <button-icon
              :color="'text-white'"
              :style="'bg-gray-700'"
              :tippy_content="'Create list'"
              ><i class="fas fa-list"></i
            ></button-icon>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "card-explore-movie",
  props: {
    data: {
      type: Object,
      required: true
    },
    width: {
      type: String,
      default: "w-48"
    }
  },
  setup() {
    const customUrlPath = (title, id) => {
      return title
        .toLowerCase()
        .split(" ")
        .join("-")
        .concat(`-${id}`);
    };

    return {
      customUrlPath
    };
  }
};
</script>
